export function sliderPopup() {
    const images = document.querySelectorAll('.swiper-slide img');
    const popup = document.getElementById('image-popup');
    const popupImg = document.getElementById('popup-img');
    const closeBtn = document.getElementById('close-popup');
    const overlay = document.getElementById('overlay');
    const body = document.body;


    if ($('.vs-slider-img').length > 0) {
        images.forEach(img => {
            img.addEventListener('click', function () {
                const hdUrl = this.getAttribute('data-hd-url');
                popupImg.src = hdUrl;
                popup.style.display = 'flex';
                overlay.style.display = 'block';
                body.style.overflow = 'hidden';
            });
        });

        const closePopup = () => {
            popup.style.display = 'none';
            overlay.style.display = 'none';
            body.style.overflow = '';
        };

        closeBtn.addEventListener('click', closePopup);

        overlay.addEventListener('click', closePopup); // Erlaubt Schließen durch Klick auf das Overlay

        popup.addEventListener('click', function (event) {
            if (event.target === popup) {
                closePopup();
            }
        });
    }
}
